export default "__VITE_ASSET__8b475f67__"